import {
  VERTICAL_SCROLL_OFFSET_DESKTOP,
  VERTICAL_SCROLL_OFFSET_MOBILE,
} from '@core/config-angular';

export const DEPLOY_PATH_VALUE = 'dist/essent/browser';
export const DEPLOY_PATH_PROVIDER = {
  provide: 'DEPLOY_PATH',
  useValue: DEPLOY_PATH_VALUE,
};

export const VERTICAL_SCROLL_OFFSET_DESKTOP_PROVIDER = {
  provide: VERTICAL_SCROLL_OFFSET_DESKTOP,
  // 56px top-nav + 1px border + 96px navbar + 1px border
  useValue: 154,
};

export const VERTICAL_SCROLL_OFFSET_MOBILE_PROVIDER = {
  provide: VERTICAL_SCROLL_OFFSET_MOBILE,
  // 72px navbar + 1px border
  useValue: 73,
};
